import { ConnectedAccount } from '../settings/types/ConnectedAccount';

export const isSocialAccountConnected = (
  connectedAccounts: ConnectedAccount[] | null,
  type: 'google' | 'facebook'
): boolean => {
  if (!connectedAccounts) {
    return false;
  }

  return connectedAccounts.some((account) => account.type.split('_').includes(type.toLowerCase()));
};
